import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api/v1';
const TIER_BASE = `${API_BASE_URL}/ai-crm/client-tier-configs`;

const apiClient = axios.create({
  baseURL: TIER_BASE,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface ClientTierConfig {
  id: string;
  companyId: string;
  name: string;
  color: string;
  sortOrder: number;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateClientTierInput {
  name: string;
  color?: string;
  isDefault?: boolean;
}

export interface UpdateClientTierInput {
  name?: string;
  color?: string;
  isDefault?: boolean;
}

export const clientTierApi = {
  list: async (): Promise<ClientTierConfig[]> => {
    const res = await apiClient.get<{ success: boolean; data: ClientTierConfig[] }>('');
    return res.data.data;
  },
  create: async (input: CreateClientTierInput): Promise<ClientTierConfig> => {
    const res = await apiClient.post<{ success: boolean; data: ClientTierConfig }>('', input);
    return res.data.data;
  },
  update: async (id: string, input: UpdateClientTierInput): Promise<ClientTierConfig> => {
    const res = await apiClient.put<{ success: boolean; data: ClientTierConfig }>(`/${id}`, input);
    return res.data.data;
  },
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/${id}`);
  },
  reorder: async (orderedIds: string[]): Promise<ClientTierConfig[]> => {
    const res = await apiClient.put<{ success: boolean; data: ClientTierConfig[] }>('/reorder', {
      order: orderedIds,
    });
    return res.data.data;
  },
};
